import React from 'react'
type Props = {
  children?: any
  hasGreyBackground?: boolean
}

const Layout = ({ children, hasGreyBackground }: Props) => {
  return <main style={{ backgroundColor: hasGreyBackground ? '#F7F7F8' : 'white' }}>{children}</main>
}

export default Layout
